import store from '@/store'
import method from './methods'

let userLicense
let storeIsGeolocated
let logInitArray = []
const stateInstance = window.ctsautoconf.STATE

function geoComplyMockupService (validGeolocation) {
  console.info(' ----- MOCKUP GAN GEOCOMPLY -----')
  new Promise((resolve, reject) => {
    var errorCode = 'verify'
    store.commit('overlayState/setGeolocationMessage', { errorCode })
    setTimeout(() => validGeolocation ? resolve(validGeolocation) : reject(validGeolocation), 5000)
  }).then(() => {
    store.commit('overlayState/setGeolocationMessage', {})
    localStorage.setItem('gcPerm', true)
    store.commit('setGeolocated', true)
    localStorage.setItem('geoError', false)
    store.dispatch('triggerBSLocationVerifiedAnimation', true)
    store.commit('overlayState/setGeolocationMessage', {})
    store.commit('setOnLoginGeolocationProgress', 'completed')
  }, () => {
    store.commit('overlayState/setGeolocationMessage', {})
    localStorage.setItem('gcPerm', false)
    store.commit('setGeolocated', false)
    let errorCode = 999
    let errorMessage = ''
    localStorage.setItem('geoError', errorCode)
    store.commit('overlayState/setGeolocationMessage', { errorCode, errorMessage })
    store.dispatch('overlayState/activeGeolocationDialog')
  }
  )
}

/*  wallet modules */
function geoComplyServiceModules (user, sessionId, reason = 'Login') {
  method.resetGeoError()
  method.geoComplyDisconnectService()
  method.connectGeoComplyService()
  logInitArray.push({ 'user_id': user, 'gelocation_reason': reason, 'state': stateInstance })
  window.GeoComply.Client.on('connect', () => {
    console.log('GC Connected')
    if (reason === 'Login' || reason === 'Retry') {
      method.showSpinnerOnStart()
    }
    if (reason === 'Login') {
      localStorage.geolocationOnLogin = true
    }
    logInitArray.push({ 'geocomply_connected': window.GeoComply.Client.isConnected() })
    window.GeoComply.Client.setLicense('')
    if (typeof localStorage !== 'undefined') {
      userLicense = ('userLicense' + stateInstance in localStorage) ? localStorage.getItem('userLicense' + stateInstance) : localStorage.setItem('userLicense' + stateInstance, undefined)
      storeIsGeolocated = ('gcPerm' in localStorage) ? localStorage.getItem('gcPerm') : localStorage.setItem('gcPerm', false)
      store.commit('setGeolocated', storeIsGeolocated)
      if (userLicense === 'undefined' || userLicense === undefined) {
        method.getGeoLicense(user, sessionId, reason)
      } else if (userLicense !== undefined) {
        console.log('LICENSE FROM localeStorage')
        console.log(JSON.parse(userLicense).License)
        window.GeoComply.Client.setLicense(JSON.parse(userLicense).License)
        method.validateLicense(user, sessionId, reason)
      }
    } else {
      method.getGeoLicense(user, sessionId, reason)
    }
  }).on('error', (errorCode, errorMessage) => {
    console.log('---- GC SERVICE ERROR ----')
    method.errorHandler(errorCode, errorMessage, user, reason)
  }).on('geolocation', (data) => {
    console.log('--- geoPacket ----')
    console.log(data)
    method.geocomplySubmit(data, user)
  }).on('log', (log) => {
    console.log(log)
  })
  console.log('logInitArray')
  console.log(logInitArray)
}
export default {
  methods: {},
  computed: {},
  components: {},
  watch: {},
  method,
  geoComplyServiceModules,
  geoComplyMockupService
}



// WEBPACK FOOTER //
// ./src/library/geocomply/index.js